<template>
    <div>

        <b-overlay :show="isLoading && !!items.length" rounded="sm" class="h-100">

            <div class="overflow-auto">
                <b-table
                    :items="items"
                    :fields="fields"
                    :busy="isLoading && !items.length"
                    small
                    show-empty
                    :empty-text="$t('noResult')"
                    class="mb-0 border-bottom"
                >
                    <template #table-busy>
                        <div class="d-flex justify-content-center my-2">
                            <b-spinner />
                        </div>
                    </template>

                    <template #cell(createdAt)="data">
                        {{ $format.date(data.item.createdAt) }}
                    </template>

                    <template #cell(action)="{item}">
                        <ButtonIcon
                            icon="x"
                            variant="link"
                            size="sm"
                            class="p-0 text-danger"
                            :disabled="isLoading"
                            :loading="requestCampaignsCategories.getLoading(`delete-${item.id}`)"
                            @click="deleteItem(item)"
                        />
                    </template>

                </b-table>
            </div>

        </b-overlay>

        <div class="w-100 my-5"></div>

        <div class="d-flex flex-wrap gap-4">
            <div class="text-nowrap d-flex align-items-center">{{ $t('assignCategory') }}</div>
            <Multiselect
                v-model="category"
                :placeholder="$t('selectField.placeholder')"
                :fetch-options-function="fetchCategories"
                :disabled-options="items"
                track-by="id"
                label="name"
                select-label=""
                :disabled="isLoading || requestCampaignsCategories.getLoading('add')"
                class="w-auto flex-grow-1"
            />
            <ButtonIcon :disabled="!category || isLoading" :loading="requestCampaignsCategories.getLoading('add')" hide-label-while-loading @click="addItem()">{{ $t('add') }}</ButtonIcon>
        </div>

    </div>
</template>



<script>
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'Categories',
        components: {
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                category: null,
                requestCampaignsCategories: this.$req('campaigns/categories'),
                requestCategoryCategories: this.$req('category/categories'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'name', label: this.$t('category') },
                    { key: 'createdAt', label: this.$t('dateAdded') },
                    { key: 'action', label: this.$t('remove') },
                ];
            },
            campaignId() {
                return this.parentComponent?.item?.id;
            },
            items() {
                return this.requestCampaignsCategories.getData() || [];
            },
            error() {
                return this.requestCampaignsCategories.getError();
            },
            isLoading() {
                return this.requestCampaignsCategories.getLoading();
            },
        },
        watch: {
            items() {
                this.$set(this.parentComponent.item, 'categories', this.items);
            },
            loading() {
                this.$store.commit('campaigns/setLoading', { key: 'categories', value: this.loading });
            },
        },
        methods: {
            fetchData() {
                this.requestCampaignsCategories.get({ urlParams: { campaignId: this.campaignId } }).catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            deleteItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.requestCampaignsCategories
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { id: item.id, campaignId: this.campaignId } })
                                .then(this.fetchData)
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
            addItem() {
                this.requestCampaignsCategories
                    .id('add')
                    .put({ urlParams: { id: this.category.id, campaignId: this.campaignId } })
                    .then(() => {
                        this.category = null;
                        this.fetchData();
                    })
                    .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            fetchCategories() {
                return this.requestCategoryCategories.get();
            },
        },
        created() {
            this.fetchData();
        },
    };
</script>
